__turbopack_context__.v({
  "container": "FormLayout-module-scss-module__N7qKOa__container",
  "content": "FormLayout-module-scss-module__N7qKOa__content",
  "footer": "FormLayout-module-scss-module__N7qKOa__footer",
  "header": "FormLayout-module-scss-module__N7qKOa__header",
  "root": "FormLayout-module-scss-module__N7qKOa__root",
});
